import {useState} from 'react'
import {fetchDocumentMaterial,type DocumentMaterial} from './library'
import './materials.css'
import PdfCanvasViewer from './PdfCanvasViewer'
import MaterialNotes from './MaterialNotes'

function kind(m:DocumentMaterial){if(m.mime_type==='application/pdf')return'PDF';if(m.mime_type.startsWith('image/'))return'Image';if(m.mime_type.includes('presentationml'))return'PowerPoint';if(m.mime_type.includes('wordprocessingml'))return'Word';return'File'}

export default function MaterialViewerModal({material,onClose}:{material:DocumentMaterial;onClose:()=>void}){
 const[frameError,setFrameError]=useState(false)
 const office=material.mime_type.includes('presentationml')||material.mime_type.includes('wordprocessingml')
 const preview='https://api.dawwin.al-ilm.net/library/materials/'+encodeURIComponent(material.id)+(office?'/preview':'/content')
 async function download(){const blob=await fetchDocumentMaterial(material.id),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=material.original_name;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000)}

 return <div className="material-modal-backdrop" onMouseDown={e=>{if(e.target===e.currentTarget)onClose()}}>
  <section className="material-modal" role="dialog" aria-modal="true" aria-label={material.display_name}>
   <header><div><span>{kind(material)}</span><strong>{material.display_name}</strong><small>Original: {material.original_name}</small></div><div><button onClick={()=>void download()}>Download</button><button className="material-modal-close" onClick={onClose} aria-label="Close">×</button></div></header>
   <div className="material-modal-body material-resource-workspace">
    <div className="material-resource-preview">
    {frameError&&<div className="material-office-note"><strong>Preview unavailable</strong><p>Could not render this file inside Dawwin.</p><button onClick={()=>void download()}>Download original</button></div>}
    {!frameError&&(material.mime_type==='application/pdf'||office)&&<PdfCanvasViewer url={preview} title={material.display_name}/>}
    {!frameError&&material.mime_type.startsWith('image/')&&<img src={preview} alt={material.display_name} onError={()=>setFrameError(true)}/>}
    </div>
    <aside className="material-resource-notes" aria-label="Material notes">
     <MaterialNotes material={material} defaultOpen/>
    </aside>
   </div>
  </section>
 </div>
}
